export const ALLOWED_FILE_TYPES = {
  // Excel files
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': ['.xlsb'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': ['.xltx'],
  'application/vnd.ms-excel.template.macroEnabled.12': ['.xltm'],
  
  // PDF files
  'application/pdf': ['.pdf'],
  
  // Word documents
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-word.document.macroEnabled.12': ['.docm'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': ['.dotx'],
  'application/vnd.ms-word.template.macroEnabled.12': ['.dotm'],
  
  // PowerPoint files
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12': ['.pptm'],
  'application/vnd.openxmlformats-officedocument.presentationml.template': ['.potx'],
  'application/vnd.ms-powerpoint.template.macroEnabled.12': ['.potm'],
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': ['.ppsx'],
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': ['.ppsm']
};

export const ALLOWED_EXTENSIONS = [
  // Excel
  '.xls', '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm',
  // PDF
  '.pdf',
  // Word
  '.doc', '.docx', '.docm', '.dotx', '.dotm',
  // PowerPoint
  '.ppt', '.pptx', '.pptm', '.potx', '.potm', '.ppsx', '.ppsm'
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB